export default {
  p1: [
    'Biotech and pharmaceutical research sectors cannot do without statistical programming. The latter helps make large volumes of complex medical data interpretable for further use and implementation in biostatistical analysis.',
    'At STATECS our experienced statistical programmers create high-quality software that collects, analyzes, and reports various types of data thus highly simplifying and facilitating the overall clinical trial procedures. This becomes possible through the production of regulatory submission-ready analysis datasets and Tables, Listings, and Figures (TLFs) which further assist in the determination of the safety and efficiency of drugs and products under investigation.',
  ],
  p2: [
    'We offer flexibility, affordability, and high quality in a single package. This means you can rest assured that our team of qualified specialists will handle your data according to the best standards to meet all your needs and requirements.',
  ],
  p3: [
    'Our statistical programming services include:',
  ],
  p4: [
    'On a different note, it’s worth mentioning that STATECS programmers are also very knowledgeable in the drug development and trial processes as well as other aspects of the pharmaceutical and therapeutic industry.',
    'High-end services combined with a caring approach towards our clients have made us one of the go-to organizations when it comes to clinical data collection, analysis, and management. ',
  ],
  props: [
    {
      firstLetter: 'H',
      title: 'igh Quality',
      iconSrc: '/assets/images/services/props/h-q.png',
      context: 'We never compromise the quality of the work we do for the sake of faster development or more deals. The success of our past collaborations is the best proof of our high-quality work.',
    },
    {
      firstLetter: 'F',
      title: 'lexibility ',
      iconSrc: '/assets/images/services/props/f.png',
      context: 'Our statistical programmers are willing to adjust to your project requirements to help you meet the set milestones within reasonable deadlines.',
    },
    {
      firstLetter: 'G',
      title: 'rowth',
      iconSrc: '/assets/images/services/props/g-r.png',
      context: 'At STATECS we are not know-it-alls. We understand that technology is evolving rapidly and in order to be more efficient, we need to keep up with the latest trends. Our specialists are constantly learning and honing their skills to deliver better results. ',
    },
    {
      firstLetter: '24/7',
      title: 'Support',
      iconSrc: '/assets/images/services/props/24-h-a.png',
      context: 'Our team is ready to help you anytime you need us. We will get back to you instantly and respond to all the inquiries you may have. ',
    },
  ],
};
